import React from 'react';
import { Navigate } from 'react-router-dom';

function RutaProtegida({ children, soloAdmin = false }) {
  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario') || 'null');

  if (!token) return <Navigate to="/login" />;

  // soloAdmin ahora verifica 'superadmin' en vez de 'administrador'
  if (soloAdmin && usuario?.rol !== 'superadmin') return <Navigate to="/dashboard" />;

  return children;
}

export default RutaProtegida;